enum FormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
}

const FormFieldsList = [FormFields.FirstName, FormFields.LastName];

export { FormFields, FormFieldsList };
